// Static product data for Ganga Irrigation
export const products = [
  {
    id: "1",
    name: "Ganga IL (Inline Lateral)",
    category: "Drip Irrigation",
    description: "Flexible lateral pipe with integrated drippers for uniform water distribution in closely spaced crops. Available in 12mm, 16mm, 20mm, 32mm sizes.",
    image_url: "/ganga-il.png"
  },
  {
    id: "2",
    name: "Ganga Filter System",
    category: "Drip Irrigation",
    description: "Ensures clean water supply with screen and sand filters. Essential for maintaining a clog-free drip irrigation system.",
    image_url: "/ganga-filter.png"
  },
  {
    id: "3",
    name: "Ganga Rain Gun",
    category: "Landscape",
    description: "High-throw sprinkler for large farms covering 20-50 meter radius. Flow rate of 3,000-24,000 LPH for sugarcane, field crops and industrial use.",
    image_url: "/landscape-rain-gun.png"
  }
];

export const blogs = [
  {
    id: "1",
    title: "Benefits of Drip Irrigation for Indian Farmers",
    excerpt: "Discover how drip irrigation can revolutionize your farming practices, save water, and increase crop yields significantly.",
    content: "Drip irrigation has emerged as a game-changer for Indian agriculture...",
    image_url: "https://images.pexels.com/photos/35067651/pexels-photo-35067651.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    author: "Dr. Rajesh Kumar",
    created_at: new Date().toISOString()
  },
  {
    id: "3",
    title: "Maintenance Tips for Drip Irrigation Systems",
    excerpt: "Essential maintenance practices to ensure your drip irrigation system runs efficiently for years to come.",
    content: "Proper maintenance is essential for keeping your drip irrigation system running efficiently...",
    image_url: "https://images.pexels.com/photos/20458078/pexels-photo-20458078.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    author: "Suresh Patel",
    created_at: new Date().toISOString()
  }
];
